import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Slider from "./../Elements/Slider";
import Specialization from "./../Elements/Specialization";
import About from "./../Elements/About";
import OurServices from "./../Elements/OurServices";

class Home extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Slider />
          <Specialization />
          <About />
          <OurServices />
        </div>
        <Footer />
      </>
    );
  }
}

export default Home;
